import { useGTM } from "gtm-react-hook";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Outlet, useNavigate } from "react-router-dom";
import { ErrorPanel } from "@/components/atoms";
import { useLayout, useOperator, useProfile } from "@/hooks";
import { clsx } from "@/utils";
import { Header } from "..";

export const PrivateContent = () => {
  const {
    layout: { sidebarOpen, fullScreen },
  } = useLayout();
  // const location = useLocation();
  const navigate = useNavigate();
  const { eventGTM } = useGTM();
  const { id: profileId } = useProfile();
  const { providerCode, flags } = useOperator();

  useEffect(() => {
    if (flags.isSuspended) navigate("/suspended");

    eventGTM("identifyUser", {
      accountUuid: profileId,
      providerKey: providerCode,
    });

    // console.log("Tracking: User Identified", {
    //   id: profileId,
    //   name: `${firstName} ${lastName}`,
    //   email,
    //   company: {
    //     id: operatorId,
    //     name: providerCode,
    //   },
    //   role: roles?.length > 0 ? roles[0] : undefined,
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerCode]);

  // useEffect(() => {
  // console.log("Tracking: Page Reload", location.pathname);
  // }, [location]);

  if (fullScreen) return <Outlet />;

  return (
    <div
      className={clsx("flex flex-1 flex-col lg:min-w-[768px]", {
        "lg:pl-[85px]": !sidebarOpen,
        "lg:pl-[270px]": sidebarOpen,
      })}
    >
      <Header />

      <ErrorBoundary fallback={<ErrorPanel messages={["Some error occured."]} />}>
        <main className="flex flex-col items-stretch bg-white px-3 sm:min-h-[calc(100vh-65px)] lg:px-5">
          <Outlet />
        </main>
      </ErrorBoundary>
    </div>
  );
};
